import React from "react";
import Register from "../components/Register/Register";

function RegisterPage() {
  return <Register />;
}
export default RegisterPage;
